"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEB_ERROR_CODES = exports.COMMON_ERROR_CODES = void 0;
/** Codici di errore trasversali. */
exports.COMMON_ERROR_CODES = {
    validation: 'validation_error',
    notFound: 'not_found',
    /** Corpo della richiesta oltre il limite del parser (413). */
    payloadTooLarge: 'payload_too_large',
    internal: 'internal_error',
};
/** Codici che produce la web app, non l'API (ADR-004). */
exports.WEB_ERROR_CODES = {
    /** La chiamata non è arrivata all'API: rete assente, CORS, API ferma. */
    network: 'network_error',
};
//# sourceMappingURL=api-error.js.map